import { render, staticRenderFns } from "./dialogDepartmentUser.vue?vue&type=template&id=b1c9b48c&scoped=true&lang=pug&"
import script from "./dialogDepartmentUser.vue?vue&type=script&lang=js&"
export * from "./dialogDepartmentUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c9b48c",
  null
  
)

export default component.exports